import { calculateSizePercent } from './helpers/calculateSizePercent';

export const gameConfig = Object.freeze({
  get width() {
    return 1920;
  },

  get height() {
    return 1080;
  },

  get sizes() {
    return {
      width: this.width,
      height: this.height,
      * [Symbol.iterator]() {
        yield this.width;
        yield this.height;
      },
    };
  },

  get center() {
    return {
      x: this.width / 2,
      y: this.height / 2,
      * [Symbol.iterator]() {
        yield this.x;
        yield this.y;
      },
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
      backgroundAlpha: 0,
      transparent: true,
    };
  },

  get backgroundAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height,
      * [Symbol.iterator]() {
        yield this.x;
        yield this.y;
      },
    };
  },


  get buyBonusPosition() {
    return {
      x: 300,
      y: 300,
      * [Symbol.iterator]() {
        yield this.x;
        yield this.y;
      },
    };
  },


  get wheelPosition() {
    return {
      x: this.width / 2,
      y: this.height / 2 - 130,
    };
  },

  get oddCrystalsPosition() {
    return {
      x: 0,
      y: 780,
    };
  },

  get gamePadPosition() {
    return {
      y: 950,
    };
  },

  get preBonusContentSize() {
    return {
      width: this.width / 2.6,
      height: this.width / 2.6,
    };
  },

  get preBonusContentContainerPosition() {
    const percent = 100 - (24 + (this.preBonusContentSize.height / this.config.height) * 100) + 10;
    return {
      x: 0,
      y: calculateSizePercent({ size: this.config.height, percent: percent / 2 }),
    };
  },

  wheel: {
    get width() {
      return 721;
    },
    get height() {
      return 721;
    },
    get position() {
      return {
        x: gameConfig.width / 2,
        y: this.height / 2 + 68,
      };
    },
    get sizes() {
      return {
        width: this.width,
        height: this.height,
        * [Symbol.iterator]() {
          yield this.width;
          yield this.height;
        },
      };
    },
    get diameter() {
      return 656;
    },
    get radius() {
      return this.diameter / 2;
    },

    get fullCircleDegree() {
      return 360;
    },
    get center() {
      const halfDiameter = this.diameter / 2;
      return {
        x: halfDiameter,
        y: halfDiameter,
        * [Symbol.iterator]() {
          yield this.x;
          yield this.y;
        },
      };
    },
    get crystalCount() {
      return 64;
    },
    get stepDegree() {
      return this.fullCircleDegree / this.crystalCount;
    },
  },

});

const [mw, mh] = [750, 750 * 16 / 9];


export const gameMobileConfig = {
  width: mw,
  __scale: 0,

  get bgScale() {
    return this.__scale;
  },
  get height() {
    return this.width * 16 / 9;
  },

  get mistake() {
    return 20;
  },

  w: window.innerWidth,
  h: window.innerHeight,

  get center() {
    const { width, height } = this.config;
    return {
      x: width / 2,
      y: height / 2,
    };
  },

  get config() {
    let w = this.width;
    let h = this.h / this.w * w;
    if (h < mh - 2) {
      h = mh;
      w = this.w / this.h * h;
    }

    return {
      width: w,
      height: h,
      transparent: false,
    };
  },
  get bgPosition() {
    const { height, width } = this.config;
    return {
      x: width / 2,
      y: height,
    };
  },
  get backgroundAnimationPosition() {
    return {
      x: this.config.width / 2,
      y: this.config.height,
    };
  },

  get preBonusContentSize() {
    return {
      width: this.config.width / 2,
      height: this.config.width / 2,
    };
  },

  get gamePadPosition() {
    return {
      y: this.config.height * .75,
    };
  },

  get wheelPosition() {
    const { width } = this.config;
    return {
      x: width / 2,
      y: calculateSizePercent({ size: this.config.height, percent: 29, minmax: [380] }),
    };
  },

  get oddCrystalsPosition() {
    return {
      y: calculateSizePercent({ size: this.config.height, percent: 65, minmax: [840] }),
    };
  },

  get buyBonusPosition() {
    return {
      y: calculateSizePercent({ size: this.config.height, percent: 54, minmax: [720] }),
    };
  },

  get bonusPadPosition() {
    return {
      y: calculateSizePercent({ size: this.config.height, percent: 63, minmax: [830] }),
    };
  },

  get preBonusContentContainerPosition() {
    const percent = 100 - (24 + (this.preBonusContentSize.height / this.config.height) * 100) + 10;
    return {
      x: 0,
      y: calculateSizePercent({ size: this.config.height, percent: percent / 2 }),
    };
  },


  calculateScale({ width }, mistake = 1.4) {
    const { width: w } = this;
    this.__scale = w * mistake / width;
    return this.bgScale;
  },
};

export const mathConfig = Object.freeze({
  halfPI: Math.PI / 2,
  doublePI: Math.PI * 2,
});

export const getFontSize = a => {
  return gameMobileConfig.config.width * a;
};
